export enum DqTagEnvHost {
  prod = "https://dmp.decentriq.com/submit",
  // TODO: ask for proper debug API url
  debug = "",
}

export enum DqTagEventApi {
  witness = "witness/v1",
  identify = "identify/v1",
  profile = "profile/v1",
  log = "log/v1",
}

export const TCF_VENDOR_ID = 1449;

export const TCF_CONSENT_IDS = [1, 2, 3, 4, 7];

export const DQ_ID_STORAGE_KEY = "dqTag:dqId";

export const MAX_EVENT_FINGERPRINTS = 1000;

export const EVENT_SAMPLING_RATE = 0.01;

export const DEBUG_QUERY_PARAM = "dqtag_debug";

export const DEBUG_SDK_QUERY_PARAM = "dqtag_debugsdk";

export const DEBUG_SDK_LS_KEY = "dqtag:debugSdk";

export const DEBUG_SDK_SESSION_LS_KEY = "dqtag:debug:session";

export const DEBUG_SDK_UI_LS_KEY = "dqtag:debug:ui";

export const DEBUG_SDK_LOGS_SS_KEY = "dqtag:debug:logs";

export const DEBUG_SDK_SCRIPT_MARKER = "data-dqtag-debug";

export const DEBUG_SDK_DEFAULT_URL =
  "https://tag.decentriq.com/onelog/dqtag-debug.min.js";

// URL params owned by the debugger (kept in sync with localStorage). The
// `dqs<n>` per-scenario result params are derived from the session sequence
// index, so there's no fixed constant for them — only this prefix.
export const DEBUG_SDK_URL_PARAMS = {
  activation: DEBUG_SDK_QUERY_PARAM, // "dqtag_debugsdk"
  integrations: "dqi", // comma-separated: "dqtag,oneid"
  currentScenario: "dqcurr", // active scenario id
  scenarioResultPrefix: "dqs", // e.g. dqs0=1 dqs1=0
  logsTab: "dqlog", // "1" when the Logs tab is active
  preserveLogs: "dqpreserve", // "1" when Preserve logs is on
  attachHem: "dqattachhem", // "1" when scenario 04 should run
  lazyLoad: "dqlazy", // "1" when SDKs only load post-consent
} as const;
